import { combineReducers, createReducer, PayloadAction } from "@reduxjs/toolkit";

import { IDuplicateCheckResult } from "Model/Omikron/IDuplicateCheckResult";
import { IDuplicateCheck } from "Model/State/IDuplicateCheck";
import { IProject } from "Model/Storage/IProject";
import {
  duplicateCheckActiveProjectIdSelect,
  duplicateCheckActiveProjectItemIdSelect,
  duplicateCheckCacheSet,
  duplicateCheckDialog,
  duplicateCheckStart,
  duplicateCheckSuccess,
  projectsClear
} from "Store/Actions";
import { hasNoElements } from "Utils/Array";

const showDialog = createReducer(false, {
  [duplicateCheckDialog.type]: (_, { payload }: PayloadAction<boolean>) => payload,
  [projectsClear.type]: () => false
});

const activeProjectId = createReducer<string>(null, {
  [duplicateCheckActiveProjectIdSelect.type]: (_, { payload: id }) => id,
  [duplicateCheckDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : null),
  [projectsClear.type]: () => null
});

const activeProjectItemId = createReducer<string>(null, {
  [duplicateCheckActiveProjectItemIdSelect.type]: (_, { payload: id }) => id,
  [duplicateCheckDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : null),
  [projectsClear.type]: () => null
});

const results = createReducer<IDuplicateCheckResult[][]>([], {
  [duplicateCheckStart.type]: () => [],
  [duplicateCheckSuccess.type]: (_, { payload: resultGroups }: PayloadAction<IDuplicateCheckResult[][]>) => {
    if (hasNoElements(resultGroups)) {
      return [];
    }

    return resultGroups;
  },
  [duplicateCheckDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : [])
});

const cache = createReducer<IProject>(null, {
  [duplicateCheckCacheSet.type]: (_, { payload: project }) => project,
  [duplicateCheckDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : null)
});

export const DuplicateCheck = combineReducers<IDuplicateCheck>({
  activeProjectId,
  activeProjectItemId,
  cache,
  results,
  showDialog
});
